/* MODO — interacciones ligeras, sin dependencias. */
(() => {
  const doc = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Header: fondo translúcido al hacer scroll ----------------------------- */
  const header = document.querySelector('[data-header]');
  const onScroll = () => {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 8);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  /* Menú móvil ------------------------------------------------------------ */
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    const label = toggle.querySelector('.visually-hidden');
    const setOpen = (open, { focus = true } = {}) => {
      toggle.setAttribute('aria-expanded', String(open));
      if (label) label.textContent = open ? 'Cerrar menú' : 'Abrir menú';
      header.classList.toggle('is-open', open);
      doc.classList.toggle('menu-open', open);
      if (open) {
        menu.hidden = false;
        requestAnimationFrame(() => menu.classList.add('is-visible'));
        if (focus) {
          const first = menu.querySelector('a');
          if (first) setTimeout(() => first.focus({ preventScroll: true }), 50);
        }
      } else {
        menu.classList.remove('is-visible');
        const done = () => { if (toggle.getAttribute('aria-expanded') === 'false') menu.hidden = true; };
        reduceMotion ? done() : setTimeout(done, 320);
        if (focus) toggle.focus({ preventScroll: true });
      }
    };
    toggle.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'));
    menu.addEventListener('click', (e) => { if (e.target.closest('[data-menu-link]')) setOpen(false, { focus: false }); });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') setOpen(false);
      if (e.key === 'Tab' && toggle.getAttribute('aria-expanded') === 'true') {
        const items = [toggle, ...menu.querySelectorAll('a, button')];
        const i = items.indexOf(document.activeElement);
        if (e.shiftKey && i <= 0) { e.preventDefault(); items[items.length - 1].focus(); }
        else if (!e.shiftKey && i === items.length - 1) { e.preventDefault(); items[0].focus(); }
      }
    });
    window.matchMedia('(min-width: 1080px)').addEventListener('change', (mq) => { if (mq.matches) setOpen(false, { focus: false }); });
  }

  /* Enlace activo según la sección visible -------------------------------- */
  const navLinks = [...document.querySelectorAll('[data-nav-link]')];
  const targets = navLinks
    .map((a) => { const id = (a.getAttribute('href') || '').split('#')[1]; const el = id && document.getElementById(id); return el ? { a, el } : null; })
    .filter(Boolean);
  if (targets.length && 'IntersectionObserver' in window) {
    const spy = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        targets.forEach(({ a, el }) => a.classList.toggle('is-active', el === en.target));
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    targets.forEach(({ el }) => spy.observe(el));
  }

  /* Apariciones al hacer scroll ------------------------------------------- */
  const reveals = document.querySelectorAll('[data-reveal]');
  if (!reduceMotion && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-in'));
  }

  /* Acordeón con altura animada ------------------------------------------- */
  const initAccordions = (scope) => scope.querySelectorAll('[data-acc]').forEach((det) => {
    if (det.dataset.ready) return; det.dataset.ready = '1';
    const summary = det.querySelector('summary');
    const body = det.querySelector('.acc__a');
    if (!summary || !body || reduceMotion) return;
    let anim;
    summary.addEventListener('click', (e) => {
      e.preventDefault();
      if (anim) anim.cancel();
      const opening = !det.open;
      if (opening) det.open = true;
      const full = body.scrollHeight;
      anim = body.animate(
        [{ height: (opening ? 0 : full) + 'px', opacity: opening ? 0 : 1 }, { height: (opening ? full : 0) + 'px', opacity: opening ? 1 : 0 }],
        { duration: opening ? 380 : 280, easing: 'cubic-bezier(.16,1,.3,1)' }
      );
      anim.onfinish = () => { if (!opening) det.open = false; anim = null; };
    });
  });

  /* Carrusel de portafolio ------------------------------------------------ */
  const initPortfolios = (scope) => scope.querySelectorAll('[data-portfolio]').forEach((root) => {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    const track = root.querySelector('[data-carousel-track]');
    const prev = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');
    if (!track) return;
    const step = () => {
      const item = track.querySelector('.project');
      return item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 18) : track.clientWidth * 0.8;
    };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 4;
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max;
    };
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    /* Vista detallada del proyecto */
    const dialog = root.querySelector('[data-project-dialog]');
    const body = dialog && dialog.querySelector('[data-project-body]');
    let lastTrigger = null;
    root.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-project-open]');
      if (!btn || !dialog || typeof dialog.showModal !== 'function') return;
      const tpl = document.getElementById(btn.dataset.projectOpen);
      if (!tpl) return;
      lastTrigger = btn;
      body.replaceChildren(tpl.content.cloneNode(true));
      const title = body.querySelector('.pmodal__title');
      if (title) dialog.setAttribute('aria-labelledby', title.id);
      dialog.showModal();
      doc.classList.add('modal-open');
      dialog.querySelector('.pmodal__inner').scrollTop = 0;
    });
    if (dialog) {
      dialog.querySelector('[data-project-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => {
        doc.classList.remove('modal-open');
        if (lastTrigger) lastTrigger.focus({ preventScroll: true });
      });
    }
  });

  initAccordions(document);
  initPortfolios(document);

  /* Barra fija de WhatsApp en celular ------------------------------------- */
  const sticky = document.querySelector('[data-sticky-cta]');
  if (sticky) {
    sticky.hidden = false;
    const hero = document.querySelector('.hero');
    const hideZones = [...document.querySelectorAll('[data-cta-final], #contacto, .site-footer')];
    let pastHero = !hero, inHide = false;
    const render = () => sticky.classList.toggle('is-visible', pastHero && !inHide && !doc.classList.contains('menu-open'));
    if ('IntersectionObserver' in window) {
      if (hero) new IntersectionObserver(([en]) => { pastHero = !en.isIntersecting; render(); }, { threshold: 0 }).observe(hero);
      const visibleZones = new Set();
      const zio = new IntersectionObserver((entries) => {
        entries.forEach((en) => en.isIntersecting ? visibleZones.add(en.target) : visibleZones.delete(en.target));
        inHide = visibleZones.size > 0; render();
      }, { threshold: 0.15 });
      hideZones.forEach((z) => zio.observe(z));
    } else { pastHero = true; render(); }
    new MutationObserver(render).observe(doc, { attributes: true, attributeFilter: ['class'] });
  }

  /* Editor de temas: reiniciar efectos al recargar secciones --------------- */
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-in'));
    initAccordions(e.target);
    initPortfolios(e.target);
  });
})();
